import { createSlice } from "@reduxjs/toolkit";
import { fetchCompanySettings, fetchUserSettings, updateCompanySetting, updateUserSetting } from "@store/settings/settings-thunks";
import { setUserRequestState } from "@store/settings/settings-slice-utils";
export const initialState = {
  user: {
    requestStateByIdentifier: {},
    data: {}
  },
  company: {}
  // device: {},
};
const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setCompanySetting: (state, action) => {
      const {
        companyId,
        body
      } = action.payload;
      if (!state.company[companyId]) {
        state.company[companyId] = [];
      }
      // Search by identifier and push new setting or replace if exists.
      const existingSetting = state.company[companyId].findIndex(item => item.identifier === body.identifier);
      if (existingSetting === -1) {
        state.company[companyId].push(body);
      } else {
        state.company[companyId][existingSetting] = body;
      }
    },
    resetSettingsState: () => initialState
  },
  extraReducers(builder) {
    builder.addCase(fetchUserSettings.pending, (state, action) => {
      setUserRequestState(state, action.meta.arg.identifiers, "pending");
    }).addCase(fetchUserSettings.fulfilled, (state, action) => {
      state.user.data[action.meta.arg.userId] = action.payload;
      setUserRequestState(state, action.meta.arg.identifiers, "succeeded");
    }).addCase(fetchUserSettings.rejected, (state, action) => {
      setUserRequestState(state, action.meta.arg.identifiers, "rejected");
    }).addCase(updateUserSetting.pending, (state, action) => {
      setUserRequestState(state, [action.meta.arg.identifier], "pending");
    }).addCase(updateUserSetting.fulfilled, (state, action) => {
      const {
        userId,
        setting
      } = action.payload;
      if (!state.user.data[userId]) {
        state.user.data[userId] = {};
      }
      // Update the specific setting with the new value and modifiedAt
      state.user.data[userId] = {
        ...state.user.data[userId],
        [setting.identifier]: setting
      };
      setUserRequestState(state, [setting.identifier], "succeeded");
    }).addCase(updateUserSetting.rejected, (state, action) => {
      setUserRequestState(state, [action.meta.arg.identifier], "rejected");
    }).addCase(fetchCompanySettings.fulfilled, (state, action) => {
      const {
        companyId
      } = action.meta.arg;
      state.company[companyId] = Object.values(action.payload);
    }).addCase(updateCompanySetting.fulfilled, (state, action) => {
      const {
        companyId,
        setting
      } = action.payload;
      if (!state.company[companyId]) {
        state.company[companyId] = [];
      }
      const existingSettingIndex = state.company[companyId].findIndex(item => item.identifier === setting.identifier);
      if (existingSettingIndex === -1) {
        state.company[companyId].push(setting);
        return;
      }
      state.company[companyId][existingSettingIndex] = setting;
    });
  }
});
export const {
  setCompanySetting,
  // setDeviceSetting,
  resetSettingsState
} = settingsSlice.actions;
export const settingsReducer = settingsSlice.reducer;